import { OdsPriorityGroups, OdsPriorityGroupsWithGrouped } from '../../../interfaces/ODSPriorityGroups'
import { IArithmeticalEvaluation } from '../../../interfaces/Rights'
import Tables from './Tables'
import EmptyState from '../../Cards/EmptyState'
import HeaderEvaluation from './HeaderEvaluation'
import PriorityGroupsIndicatorsView from './PriorityGroupsIndicatorsView'
import { ODS } from '../../../utils/const'

type RelatedIndicatorsData =
    | ({ type: 'ods' } & OdsPriorityGroups)
    | ({ type: 'grupos-prioritarios' } & OdsPriorityGroupsWithGrouped);
interface RelatedIndicatorsProps {
    data: RelatedIndicatorsData | null;
    arithmeticalEvaluation: IArithmeticalEvaluation[];
    period: string;
    pagination: {
        currentPage: number;
        pageSize: number;
    };
    handlePageChange: (page: number) => void;
    handleSelectTypeIndicator: (typeOfIndicatorName: string) => void;
    selectedTypeIndicator: string | null;
}

const RelatedIndicators = ({
    data,
    arithmeticalEvaluation,
    period,
    pagination,
    handlePageChange,
    handleSelectTypeIndicator,
    selectedTypeIndicator
}: RelatedIndicatorsProps) => {
  
    if (!data) {
        return (
            <EmptyState message="Hasta el momento no existen indicadores a mostrar" />
        );
    }

    const hasIndicators = data.indicadores?.length > 0;

    return (
        <section className="flex flex-col w-full">
            <h4 className="text-tmedium md:text-tlarge text-brand-green-30">
                Indicadores del monitor relacionados
            </h4>

            {!hasIndicators ? (
                <EmptyState message={data.mensaje_informativo ?? "Hasta el momento no existen indicadores a mostrar"} />
            ) : (
                <>
                    <HeaderEvaluation arithmeticalEvaluation={arithmeticalEvaluation} />
                    {data.type === ODS ? (
                        <Tables
                            indicadores={data.indicadores}
                            period={period}
                            pagination={pagination}
                            handlePageChange={handlePageChange}
                            odsSelected={data}
                            module={data.type}
                        />
                    ) : (
                        <PriorityGroupsIndicatorsView
                            data={data}
                            selectedTypeIndicator={selectedTypeIndicator}
                            handleSelectTypeIndicator={handleSelectTypeIndicator}
                            pagination={pagination}
                            period={period}
                            handlePageChange={handlePageChange}
                            module={data.type}
                        />
                    )}
                </>
            )}
        </section>
    );
};

export default RelatedIndicators